import { ArticlesWithLoadState, ArticleWithLoadState } from '@shared/shared/interfaces/article.interfaces';

export interface ArticlesState {
  articles: ArticlesWithLoadState;
  article: ArticleWithLoadState;
}

export interface ArticlesReducersState {
  data: {
    articles: ArticlesWithLoadState;
    article: ArticleWithLoadState;
  };
}

export const initialState: ArticlesState = {
  articles: {
    count: 0,
    current: 0,
    next: '',
    page_size: 0,
    previous: '',
    results: [],
    loaded: false,
    loading: false,
  },
  article: {
    resource: '',
    id: 0,
    url: '',
    slug: '',
    title: '',
    created: '',
    subhead: '',
    introduction: '',
    hero_video: '',
    body_html: '',
    body_markdown: '',
    call_to_action_text: '',
    feature_image: '',
    tags: [],
    sections: [],
    images: [],
    loaded: false,
    loading: false,
  },
};
